<span
    #textRef
    [ngbTooltip]="isTruncated ? text : null"
    class="badge fs-12 fw-500 bg-danger-subtle text-danger text-truncate mt-2 d-inline-block"
    [style.max-width]="maxWidth"
    style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
>
  {{ text }}
</span>
